import transpileTypeScript from '../shared/transpileTypeScript'
import { collectAssetReferencesFromRenderData } from '../shared/assetReferences'
import type { RenderData } from '../assetTypes'

const stripModuleSyntax = (code: string) =>
  code
    .replace(/import\s+[^;]+['"]phaser['"];?/gi, '')
    .replace(/export\s+default/g, '')
    .replace(/export\s+\{[^}]+\};?/gi, '')

const learningTemplatesRuntime = (content: string) => {
  const compiled = transpileTypeScript(stripModuleSyntax(content || ''))
  const wrapped = `const container = document.getElementById('phaser-container');\n${compiled}`
  return `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      body {
        margin: 0;
        background-color: #ffffff;
        color: #111827;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        display: flex;
        flex: 1;
        min-height: 100vh;
        padding: 0;
      }
    </style>
  </head>
  <body>
    <div id="phaser-container" style="width: 100%; height: 100%;"></div>
    <script src="https://cdn.jsdelivr.net/npm/phaser@3.60.0/dist/phaser-arcade-physics.min.js"></script>
    <script>
      const trellis = window.trellis
      const renderLog = (message) => {
        trellis.log(message)
      }
      renderLog('Render runtime initialized')
    </script>
    <script>
      (function () {
        const trellis = window.trellis
        const renderLog = (message) => {
          trellis.log(message)
        }
        try {
          const execute = new Function('Phaser', ${JSON.stringify(wrapped)})
          execute(window.Phaser)
          renderLog('Learning template render executed')
        } catch (error) {
          renderLog('Learning template render failed: ' + (error && error.message ? error.message : error))
          document.body.innerHTML = '<div style="padding:16px;font-family:monospace;color:#b91c1c">' +
            'Failed to render asset. ' + (error && error.message ? error.message : error) +
            '</div>'
        }
      })()
    </script>
  </body>
</html>`
}

export default learningTemplatesRuntime

export const collectAssetReferences = (content: string, renderData?: RenderData) =>
  collectAssetReferencesFromRenderData(content, renderData)
